import { log } from '../log.js';
import { getDomainsClient } from '../domains-client/domains-client.js';

interface RunSuggestDomainsParams {
  json?: boolean;
  limit?: number;
  query: string;
  tlds?: string[];
}

export async function runSuggestDomains({
  json,
  limit,
  query,
  tlds,
}: RunSuggestDomainsParams): Promise<void> {
  const client = await getDomainsClient();
  const suggestions = await client.search({ limit, query, tlds });

  if (json) {
    log(JSON.stringify({ suggestions }));
    return;
  }

  if (suggestions.length === 0) {
    log(`No available domains found for "${query}".`);
    return;
  }

  for (const suggestion of suggestions) {
    log(suggestion.domain);
  }

  log('\nBuy one with: wix account domain buy <domain>');
}
